$(document).ready( function() {
	// SLIDERS
	//if ($('.celebrity-wrapper').length != 0) BOLD.BMS.HE.Slider( $('.celebrity-wrapper'), { "autoPlay": 2500 } );
	//if ( $('.youtube-slider').length != 0 ) BOLD.BMS.HE.Slider( $('.youtube-slider'),  { "autoPlay": false } );
	//if ( $(window).width() <= 798 && $('.index').find('.logo-list').length != 0 ) BOLD.BMS.HE.Slider( $('.index').find('.logo-list'),  { "pageDots":false, "autoPlay": 2500 } );

	var $landingPageSliderWrapper = $('.landingpage-slider-wrapper'),
		$landingPageCollectionTitleWrapper = $('.landingpage-collectiontitle-wrapper'),
		$shopCollectionHeading = $('.shop-by-collection-heading'),
		$isCarousel = $('.is-a-carousel'),
		$youtubePopup = $('a.v2-youtube-link'),
		$bundledSlider = $('.bundled-slider'),
		$discoverMoreSlider = $('.discovermore-slider-wrapper'),
		$hemperCollabSlider = $('.hempercollaboration-wrapper'),
		$hemperPublicationSlider = $('.hemperpublication-wrapper'),
		$hemperCommunitySlider = $('.hempercommunity-wrapper'),
		$homepagev2Slideshow = $('.homepage-v2-slideshow'),
    $homepageTabsTitleWrapper = $('.tabs-title-wrapper'),
    $displayMoreArticles = $('.display-more-articles'),
    $colorSelectorDropdown = $('.select.color-option-name'),
    $productAccessories = $('.product-accessories');

	$shopCollectionHeading = $('.shop-by-collection-heading');
	if ( $shopCollectionHeading.length ) {
	$shopCollectionHeading.on('click', function(e) {
		e.preventDefault();
		$(this).closest('.sidebar').toggleClass('open-sidebar');
		$('body.collection').toggleClass('lock-scroll');
		$('.landing-page-section').toggleClass('lock-scroll');
	});
	}

	if ($landingPageSliderWrapper.length ) {
		$landingPageSliderWrapper.each(function() {
			var $this = $(this);
			BOLD.BMS.HE.Slider( $this, { "autoPlay": 5000 } );
		});
	}

	if ( $landingPageCollectionTitleWrapper.length ) {
		$landingPageCollectionTitleWrapper.find('.featured-tab-title a').on('click', function(e) {
			e.preventDefault();
			var $this = $(this),
				$thisParent = $this.closest('.landingpage-collectionfeatured-wrapper'),
				thisFor = $(this).attr('data-for');
				$thisParent.find('.featured-tab-title').removeClass('active');
				$this.closest('.featured-tab-title').addClass('active');
				$thisParent.find('.landingpage-collectioncontent-wrapper').find('.featured-collection-section-tabs').removeClass('active');
				$thisParent.find('.landingpage-collectioncontent-wrapper').find('.featured-collection-section-tabs[data-title="'+ thisFor +'"]').addClass('active');
		});
	}

	if ( $homepageTabsTitleWrapper.length ) {
		$('.tabs-wrapper').find('.tab').first().addClass('active');
		$('.tabs-title-wrapper').find('.tab-title').first().addClass('active');
		$homepageTabsTitleWrapper.find('.tab-title a').on('click', function(e) {
			e.preventDefault();
			var $this = $(this),
				$thisParent = $this.closest('.homepage-v2-tabs'),
				thisFor = $(this).attr('data-for');
				$thisParent.find('.tab-title').removeClass('active');
				$this.closest('.tab-title').addClass('active');
				$thisParent.find('.tabs-wrapper').find('.tab').removeClass('active');
				$thisParent.find('.tabs-wrapper').find('.tab[data-title="'+ thisFor +'"]').addClass('active');
		});
	}
if ( $('.blog-homepage').find('.featured-blog.mobile-only').length ) {
    var $this = $('.blog-homepage').find('.featured-blog.mobile-only');
		BOLD.BMS.HE.Slider( $this, { "groupCells": true, "autoPlay": 10000, "pageDots": true } );
  }

});
function createCategorySlider() {
  var $subCollection = $('.subcollection-container');

  $subCollection.flickity({
    cellSelector: '.sub-collection-grid',
    cellAlign: 'left',
    contain: true,
    freeScroll: true,
    wrapAround: true,
    accessibility: true,
    pageDots: false,
    groupCells: true,
    imagesLoaded: true
  });

  $subCollection.find('button.flickity-prev-next-button.next').html('<svg><path d="M13,10.5,2.15,21,0,18.92,8.7,10.5,0,2.08,2.15,0Z" class="arrow"></path></svg>');
  $subCollection.find('button.flickity-prev-next-button.previous').html('<svg><path d="M0,10.5L10.9,0L13,2.1l-8.7,8.4l8.7,8.4L10.9,21L0,10.5z" class="arrow"></path></svg>');
}

$(document).ready(function () {
	createCategorySlider();
});
$(document).ready(function () {
$('.mobile_nav.dropdown_link').on('click', function() {
        $('#mobile-main-nav').addClass('mobile-menu-active');
      })
  $('.mobile-main-nav__close').on('click', function() {
        $('#mobile-main-nav').removeClass('mobile-menu-active');
    $('.mobile_nav.dropdown_link>div').removeClass('open');
      })

  $('.tab-icon-selector').on( "click", function(e) {
    if($(this).attr('data-title') != 'blog') {
    e.preventDefault();
        }
    var datatext = $(this).attr('data-title'); 
    $('.tab-icon-selector').removeClass('active');
     $(this).addClass('active');
    $(".mobile-tab-menu-panel").each(function(){
       $(this).removeClass('active');
      if($(this).attr('data-content') == datatext) {
            $(this).addClass('active');
        }
    });
    //$('#mobile-main-nav').removeClass('mobile-menu-active');
});
});
